<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <side-bar
        :background-color="sidebarBackground"
        short-title="Cari"
        title="Cari">
      <template slot="links">
        <template v-for="(menuItem, key) in menu" v-if="menuItem.showing">
          <sidebar-dropdown v-if="menuItem.children && menuItem.children.length > 0" :color="menuItem.color" :key="key"
                            :name="menuItem.label" :icon="menuItem.icon">
            <sidebar-item v-for="(subItem, subKey) in menuItem.children" :key="subKey" :label="subItem.label"
                          :icon="subItem.icon" :to="{...subItem.to,params:subItem.params}"/>
          </sidebar-dropdown>
          <sidebar-item v-else :color="menuItem.color" :key="key" :label="menuItem.label" :icon="menuItem.icon"
                        :to="{...menuItem.to,params:menuItem.params}"/>
        </template>

<!--        <li class="nav-item">-->
<!--          <a href="#" @click.prevent="logoutAction" class="nav-link">-->
<!--            <i class="ni ni-user-run text-default"></i>-->
<!--            <span class="nav-link-text">Çıkış Yap</span>-->
<!--          </a>-->
<!--        </li>-->

      </template>
    </side-bar>
    <div class="main-content" :data="sidebarBackground">
      <dashboard-navbar></dashboard-navbar>

      <div @click="toggleSidebar">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
        <!--        <content-footer v-if="!$route.meta.hideFooter"></content-footer>-->
      </div>
    </div>

    <b-modal
        title="Üyeliğinizi Yenileyin"
        v-model="accountExpired"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop>
      <FrozenRenewAccount v-if="user.company.is_frozen "/>
      <renew-account v-else />
      <template v-slot:modal-footer>
        <div class="w-100 text-center">
          <img src="/img/iyzico-logo-pack.png">
        </div>
      </template>
    </b-modal>


    <b-modal
        title="Bilgilerinizi Tamamlayın"
        v-model="accountNotActivated" size="xl"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop>
      <activate-account/>
      <template v-slot:modal-footer>
        <b-button :to="{name: 'settings'}" variant="primary">Ayarlar'a Git</b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import moment from 'moment'
import DashboardNavbar from './DashboardNavbar.vue';
import {FadeTransition} from 'vue2-transitions';
import RenewAccount from '../components/RenewAccount.vue';
import FrozenRenewAccount from '../components/FrozenRenewAccount.vue';
import ActivateAccount from '../components/ActivateAccount.vue';

import menu from '../config/menu';
import SidebarDropdown from '../components/SidebarDropdown'
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    SidebarDropdown,
    DashboardNavbar,
    FadeTransition,
    RenewAccount,
    ActivateAccount,
    FrozenRenewAccount
  },
  data() {
    return {
      menu,
      sidebarBackground: 'vue' //vue|blue|orange|green|red|primary
    };
  },
  computed: {
    ...mapGetters(['user']),
    accountExpired() {
      return this.user ? (moment(this.user.company.expiration_date).diff(moment()) < 0 || this.user.company.is_frozen==1) : false;
    },
    accountNotActivated() {
      return this.$route.name === 'settings' ? false :
          (
              this.user ? !this.user.company.title || !this.user.company.phone || !this.user.company.phone2 || !this.user.company.sms_confirmed : false
          );
    }
  },
  methods: {
    ...mapActions(['getUser', 'logout']),
    logoutAction() {
      this.logout().then(() => {
        this.$router.go({name: 'login'});
      })
    },
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  },
  async mounted() {
    await this.getUser()
    this.menu.forEach(item => {
      if (item.label == 'Çalışan ve Maaşlar' && !this.user.salary_permission)
        item.showing = false;

      if (item.label == 'Kasa' && !this.user.safe_permission)
        item.showing = false;
      if (item.label == 'Raporlar' && !this.user.report_permission)
        item.showing = false;
      if (item.label == 'Ürün Yönetimi' && !this.user.service_permission)
        item.showing = false;
      if (item.label == 'Yeni Ürün Siparişi' && !this.user.newservice_permission)
        item.showing = false;
      if (item.label == 'Hızlı Satış' && !this.user.fastsale_permission)
        item.showing = false;
      if (item.label == 'Cari Yönetimi' && !this.user.client_permission)
        item.showing = false;

      if (item.label == 'Provalar' && !this.user.appointment_permission)
        item.showing = false;

      if (item.label == 'Kuaför Randevuları' && !this.user.coiffeurappointment_permission)
        item.showing = false;
      if (item.label == 'SMS Modülü' && !this.user.sms_permission)
        item.showing = false;
      if (item.label == 'Tanımlamalar' && !this.user.definition_permission)
        item.showing = false;

    })
  }
};
</script>
<style lang="scss">
</style>
